import React, { useCallback } from 'react';
import { Spacer } from '../common/Spacer';
import { SiteStyle } from '../common/SiteStyle';
import { Reporting } from '../common/Reporting';
import { SiteHeader } from '../common/SiteHeader';
import { SummaryBlock } from '../common/SummaryBlock';
import { Badge } from 'react-bootstrap';
import { ActionButton } from '../common/ActionButton';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { Logo } from '../common/Logo';
import crossWhite from '../../assets/svg/Cross-white.svg';
import { useReportState } from '../../state/state';

export const CheckinFailed = () => {
    const history = useHistory();
    const { token } = useParams<Token>();
    const { reportSuccess } = useReportState();

    const onClick = useCallback(() => {
        reportSuccess('')
        history.replace(`/welcome/${token}`);
    }, [reportSuccess]);

    return (
        <>
            <SiteStyle/>
            <Reporting/>
            <Spacer height="2em"/>
            <SiteHeader/>
            <Spacer height="2em"/>
            <SummaryBlock display className="text-center">
                <Badge variant='danger' pill className="py-2 pl-2 pr-3">
                    <div className="d-flex flex-row">
                        <img alt="" src={crossWhite} className="check-result"/>
                        <div className="my-auto pl-1 result-text">Check In Unsuccessful</div>
                    </div>
                </Badge>
            </SummaryBlock>
            <Spacer height="1em"/>
            <SummaryBlock display className="text-center text-not-dim">
                Based on your responses to the check in questions you are unable to check in to this site at the moment.
            </SummaryBlock>
            <Spacer height="1em"/>
            <ActionButton text="Close" onClick={onClick}/>
            <Spacer height="4em"/>
            <Logo/>
        </>
    )
}
